export enum PlanPaymentType {
	EFT = 'EFT',
	DirectBill = 'Direct Bill',
	CreditCard = 'Credit Card',
}
